



























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import GasdataAnalyze from "./gasdata-analyze.vue";
import * as XLSX from "xlsx";
//import Echarts from "./Echarts.vue";

class PageThRealTimeDataRequest extends PageRequest {
  FilterText: string;
  etype:Number;
  // wId:Number;
  //fId:Number;
  cId: Number;
  EndTime: Date=new Date();
  snid: string;
  Time: string;
  displayId:number;
}
class PageCompanyRequest {
  cId: Number;
  ftId:Number;
  wId:Number;
}
@Component({
  components: { GasdataAnalyze },
})
export default class ThRealTimeDatas extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  analyseModalShow: boolean = false;
  userName: string;
  cId: Number;
  list1;
  datalist=[];
  snid:string='';
  wflocation:string='';
  selDateTime:Date=new Date();
  datalist1 = [];
  temp:string = '';
  humi = [];
  eid:string='';
  yieldly:string='';
  years:string='';
  grade:string='';
  selwarehouselist = [];
  selfloorlist = [];

  get list() {
    return this.$store.state.gasequipment.list;
  }
  get loading() {
    return this.$store.state.gasequipment.loading;
  }

  // showEcharts() {
  //   this.componentKey += 1;
  // }

  // onClickTime(value, date) {
  //   this.pagerequest.Time = value;
  // }
  selCompany(value: Number) {
    this.$store.state.gasequipment.pageSize=10;
    this.$store.state.gasequipment.currentPage=1;
    this.$store.state.gasequipment.totalCount=0;
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
    this.getfloor();
    this.getPage();
  }
  //库区
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    // this.getwarehouse();
    //   this.getfloor();
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
      this.$store.state.gasequipment.currentPage=1;
       this.getPage();
  }
  //库房
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
      // this.getfloor();
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
      this.$store.state.gasequipment.currentPage=1;
       this.getPage();
  }
  //楼层
  selfloor(value:Number){
    this.$store.state.gasequipment.currentPage=1;
    this.getPage();
  }
  pageChange(page: number) {
    this.$store.commit("gasequipment/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("gasequipment/setPageSize", pagesize);
    this.getPage();
  }
  getsearch(){
     this.$store.state.gasequipment.currentPage=1;
    this.getPage();
  }
  async getPage() {
    this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pagerequest.etype = 0;
    //filters
    this.datalist = await this.$store.dispatch({
      type: "gasequipment/GetRealPaged",
      data: this.pagerequest,
    });
  }

 
  get pageSize() {
    return this.$store.state.gasequipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.gasequipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.gasequipment.currentPage;
  }
  getuserName() {
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get gasequipment() {
    return this.$store.state.gasequipment.list;
  }
  gasequipmentlist() {
    return this.$store.state.gasequipment.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }
  analyse() {
    this.selDateTime=this.pagerequest.EndTime;
    this.analyseModalShow = true;
  }
  setmac(val){
    this.snid=val;
  }
  setsmoke(sid){
    let smokelist = this.smokecriblist();
    for(let entry of smokelist){
      if(sid == entry.id){
        this.yieldly = entry.yieldly;
        this.years = entry.year;
        this.grade = entry.grade;
        break;
      }
    }
  }
  setNames(paramftid,paramwid,paramfid,paramlocation){
    let ftid = paramftid;
    let wid = paramwid;
    let fid = paramfid;
    let ftlist = this.factorylist(); 
    for (let entry of ftlist) {
      if(ftid==entry.id){
        ftid=entry.fName;
        break;
      }
    }
    let wlist = this.warehouselist(); 
    for(let entry of wlist) {
      if(wid==entry.id){
        wid=entry.wName;
        break;
      }
    }
    let flist = this.floorlist();
    for(let entry of flist){
      if(fid == entry.id){
        fid = entry.fName;
        break;
      }
    }
    this.wflocation =ftid + wid + fid + paramlocation;
    // if(ftid == 0){
    //   this.wflocation =wid + fid + paramlocation;
    // }
    if(paramlocation == null){
      this.wflocation = ftid + wid + fid;
    }

  }

  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
     {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
    {
      title: "库房",
      key: "wName",
      render: (h, params) => {
        let wId = params.row.wId;
        let wlist = this.warehouselist();
        for (let entry of wlist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fName",
      render: (h, params) => {
        let fId = params.row.fId;
        let flist = this.floorlist();
        for (let entry of flist) {
          //console.log(entry.id); // 1, "string", false
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "snid",
    },
    // {
    //   title: "剩余电量",
    //   width:100,
    //   key: "electric",
    //   render: (h, params) => {
    //    let Electric = params.row.electric;
    //      let username = this.getuserName();
    //     if(username !== "admin"){
    //       if(Electric > 30){
    //         Electric = "电量充足";
    //       }
    //       else if(Electric > 11 && Electric < 31){
    //          Electric = "电量一般";
    //       }
    //       else{
    //          Electric = "电量不足";
    //       }
    //     }
    //     else{
    //       Electric= Electric.toString() + "%";
    //     }
    //     return h("span",Electric);
    //   },
    // },
    // {
    //   title: "信号强度",
    //   width:100,
    //   key: "signale",
    //   render: (h, params) => {
    //     return h("span", params.row.signale+'%');
    //   },
    // },
    {
      title: "氧气浓度",
      key: "oxygenC",
       render: (h, params) => {     
        if(params.row.oxygenC==null){
             return h("span", '无');
        }
        return h("span", params.row.oxygenC+'PPM');
      },
    },
   {
      title: "二氧化碳浓度",
      key: "carbondioxideC",
      render: (h, params) => {
          if(params.row.carbondioxideC==null){
             return h("span", '无');
        }
        return h("span", params.row.carbondioxideC+'PPM');
      },
    },
    {
      title: "氮气浓度",
      key: "nitrogenC",
      render: (h, params) => {
          if(params.row.nitrogenC==null){
             return h("span", '无');
        }
        return h("span", params.row.nitrogenC+'PPM');
      },
    },
    {
      title: "磷化氢浓度",
      key: "chlorinehydrideC",
      render: (h, params) => {
          if(params.row.chlorinehydrideC==null){
             return h("span", '无');
        }
        return h("span", params.row.chlorinehydrideC+'PPM');
      },
    },
    // {
    //   title: "一氧化碳浓度",
    //   key: "carbonicoxideC",
    //   render: (h, params) => {
    //       if(params.row.carbonicoxideC==null){
    //          return h("span", '无');
    //     }
    //     return h("span", params.row.carbonicoxideC+'%');
    //   },
    // },
    {
      title: "更新时间",
      width:150,
      key: "endtime",
      render: (h, params) => {
        let endtime ='';
        
        endtime=this.GetDay(params.row.endtime)+' '+this.GetMinutes(params.row.endtime);
        return h("span", endtime);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 100,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "2px",
              },
              on: {
                click: () => {
                  
                 this.setmac(params.row.snid);
                 let strtime = params.row.endtime;
                 let datetime1 = new Date(params.row.endtime);
                  if(strtime.toString() == '0001-01-01T00:00:00'){
                    datetime1 = new Date();
                 }
                 this.pagerequest.EndTime = datetime1;
                 this.setsmoke(params.row.scId);
                 this.setNames(params.row.ftId,params.row.wId,params.row.fId,params.row.locationName);
                  this.$store.commit("gasequipment/analyse", params.row);
                   //console.log(this.mac+'aaa');
                  this.analyse();
                },
              },
            },
            "数据分析"
          ),
         
        ]);
      },
    },
  ];

  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }

  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
    }
    async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  created() {
     this.$store.state.gasequipment.pageSize=10;
    this.$store.state.gasequipment.currentPage=1;
    this.$store.state.gasequipment.totalCount=0;
    this.getuserName();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }
    this.getwarehouse();
    this.getfloor();
    this.getfactory();
    this.getPage();
  }
}
